import { useCallback } from "react";
import EntitySearchBox from "../../common/crud/EntitySearchBox";
import useUser from "../../hooks/store/user";
import usePermissions from "../../hooks/usePermissions";

export const CustomersSearch = () => {
  const {
    getUserDataAction,
    setPageNumberAction,
    setRowsPerPageAction,
    searchUserDataAction,
    rowsPerPage,
    page,
    getUsersWithClientAction,
    searchUserWithClientAction,
  } = useUser();
  const { isClient, clientId } = usePermissions();

  const handleResetPagination = useCallback(
    (paginationState) => {
      setRowsPerPageAction(paginationState.rowsPerPage);
      setPageNumberAction(paginationState.page);
    },
    [setPageNumberAction, setRowsPerPageAction]
  );

  const loadPage = useCallback(
    ({ limit, offSet, signal }) => {
      if (isClient && clientId) {
        getUsersWithClientAction({
          clientId,
          limit,
          offSet,
          signal,
        });
        return;
      }

      getUserDataAction({
        limit,
        offSet,
        signal,
      });
    },
    [clientId, getUserDataAction, getUsersWithClientAction, isClient]
  );

  const searchPage = useCallback(
    ({ limit, name, offSet, signal }) => {
      if (isClient && clientId) {
        searchUserWithClientAction({
          clientId,
          name,
          signal,
          limit,
          offSet,
        });
        return;
      }

      searchUserDataAction({
        name,
        signal,
        limit,
        offSet,
      });
    },
    [clientId, isClient, searchUserDataAction, searchUserWithClientAction]
  );

  return (
    <EntitySearchBox
      loadPage={loadPage}
      onResetPagination={handleResetPagination}
      page={page}
      placeholder="Search User"
      rowsPerPage={rowsPerPage}
      searchPage={searchPage}
    />
  );
};
